// frontend/src/views/MagicLinkHandler.jsx

import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { validateMagicLink } from '../services/authService';
import { setStoredSession, clearStoredSession  } from '../hooks/useHashSession';
import { useTranslation } from '../i18n';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


const MagicLinkHandler = () => {
  const { _ } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleValidation = async () => {
       if (!token) {
        setError(_("Token not provided. Redirecting..."));
        setLoading(false);
        clearStoredSession();
        localStorage.removeItem('accessToken');
        setTimeout(() => navigate('/', { replace: true }), 3000);
        return;
      }

      try {
        const { accessToken, hash, role } = await validateMagicLink(token);

        if (accessToken) localStorage.setItem('accessToken', accessToken);
        // Se utiliza el hash del grupo para la sesión
        setStoredSession(hash, role);

        if (role === 'leader') {
          navigate('/invitations');
        } else {
          navigate('/members');
        }

      } catch (err) {
        setError(_("Invalid or expired link. Please try again."));
        clearStoredSession();
        localStorage.removeItem('accessToken');
        setTimeout(() => navigate('/', { replace: true }), 7000);
      } finally {
        setLoading(false);
      }
    };

    handleValidation();
  }, [token, navigate]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p>{_('Validating your access link...')}</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[60vh] px-4">
        <div
          className="notice notice-error text-center"
          role="alert"
          aria-live="assertive"
        >
          <p className="notice-title flex items-center gap-2 justify-center">
            {/* Icono opcional */}
            <FontAwesomeIcon icon="triangle-exclamation" className="mr-1" />
            {error}
          </p>
          <p className="notice-desc">
            {_('You will be redirected shortly.')}
          </p>
          <p className="notice-desc">
            {_('In the form, use the authentication code you received.')}
          </p>
        </div>
      </div>
    );
  }

  return null;
};

export default MagicLinkHandler;